import React from 'react';
import DocumentTitle from 'react-document-title';
import COLORS from '../../constants/colors';
import ProductTitle from '../../components/ProductTitle';
import ProductLineup from '../../components/ProductLineup';
import ProductVariant from '../../components/ProductVariant';
import ProductCustom from '../../components/ProductCustom';
import ProductFAQ from '../../components/ProductFAQ';
import ProductDetails from '../../components/ProductDetails';
import ProductStyleElements from '../../components/ProductStyleElements';
import ProductImagery from '../../components/ProductImagery';
import ProductPlanningTesting from '../../components/ProductPlanningTesting';
import ProductEcommerce from '../../components/ProductEcommerce';
import ProductFooter from '../../components/ProductFooter';
import SectionTitle from '../../components/SectionTitle';
import landingPageImage from './assets/landing_page_image.png';
import landingDetailImage from './assets/landing_detail.png';
import websiteImage from './assets/website_image.png';
import websiteDetailImage from './assets/website_detail.png';
import advancedImage from './assets/advanced_image.png';
import advancedDetailImage from './assets/advanced_detail.png';
import footerBackground from './assets/footer.png';

const landingPageVariant = (
  <section>
    <div>
      <p>1 Page Design</p>
      <p>Desktop & Mobile Views</p>
    </div>
    <div>
      <p>Button Styles, Animations</p>
    </div>
    <div>
      <p>
        Great for testing an idea or launching a new business concept.
        Use it to announce an event or gain newsletter subscriptions.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const websiteVariant = (
  <section>
    <div>
      <p>3-5 Page Designs</p>
      <p>Desktop & Mobile Views</p>
    </div>
    <div>
      <p>Button Styles, Animations</p>
      <p>Font & Type guide</p>
      <p>Color Palette</p>
    </div>
    <div>
      <p>
        Great for launching a new business or redesigning your existing
        marketing pages.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const advancedVariant = (
  <section>
    <div>
      <p>Wireframing</p>
      <p>Prototyping</p>
    </div>
    <div>
      <p>10-15 Page Designs</p>
      <p>Desktop & Mobile Views</p>
    </div>
    <div>
      <p>Interactive Animations</p>
      <p>1-3 Ecommerce Pages</p>
    </div>
    <div>
      <p>
        Great for the startups looking to stand out on the web with custom
        animations and Ecommerce Pages.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const landingDescription = (
  <section>
    <div>
      <p>
        Landing pages are ideal for testing an idea or launching a new business
        concept.
      </p>
    </div>
    <div>
      <p>
        Use it to announce an event or gain newsletter subscriptions.
      </p>
    </div>
  </section>
);

const landingIncludes = [
  "1 page design",
  "desktop and mobile views",
  "button styles",
  "button animations"
];

const websiteDescription = (
  <section>
    <div>
      <p>
        Full websites are great for launching new businesses or redesigning your
        existing marketing pages.
      </p>
    </div>
    <div>
      <p>
        They come with full-page designs, icons, high-quality photos, and
        various screen views.
      </p>
    </div>
  </section>
);

const websiteIncludes = [
  "3-5 page designs",
  "desktop and mobile views",
  "button styles, animations",
  "fonts and type guide",
  "color palette"
];

const advancedDescription = (
  <section>
    <div>
      <p>
        Advanced sites are for the startups looking to stand out on the web.
        They make it that much better for users to buy from you and extremely
        delightful in the process.
      </p>
    </div>
    <div>
      <p>
        Along with intuitive icons and beautiful illustrations, they come with
        page animations throughout.
      </p>
    </div>
  </section>
);

const advancedIncludes = [
  "5-10 page designs",
  "ecommerce design",
  "interactive animations",
  "1-3 Ecommerce Pages",
  "button styles, animations",
  "fonts and type guide",
  "color palette"
];


const color = COLORS.BLUE;

function Website() {
  return (
    <DocumentTitle title='DesignCue - Website Design'>
      <div>
        <ProductTitle>Website Design</ProductTitle>
        <ProductLineup>
          <ProductVariant
            image={landingPageImage}
            title="Landing Page"
            details={landingPageVariant}
            cost="$1000 - 7 days"
            query={{ product: 'Landing Page' }}
            color={color}
          />
          <ProductVariant
            image={websiteImage}
            title="Website"
            details={websiteVariant}
            cost="$5,000 - 10 days"
            query={{ product: 'Website' }}
            color={color}
          />
          <ProductVariant
            image={advancedImage}
            title="Advanced Site"
            details={advancedVariant}
            cost="$10,000 - 3 weeks"
            query={{ product: 'Advanced Site' }}
            color={color}
          />
        </ProductLineup>
        <ProductCustom />
        <ProductFAQ />
        <div className="mt100 mb100">&nbsp;</div>
        <SectionTitle color={color}>
          WHAT'S INCLUDED
        </SectionTitle>
        <hr className="mt20"/>
        <ProductDetails
          title="Landing Page"
          color={COLORS.GREEN}
          includes={landingIncludes}
          description={landingDescription}
          image={landingDetailImage}
        />
        <hr />
        <ProductDetails
          title="Full Website"
          color={COLORS.BLUE}
          includes={websiteIncludes}
          description={websiteDescription}
          image={websiteDetailImage}
        />
        <hr />
        <ProductDetails
          title="Advanced Site"
          color={COLORS.PURPLE}
          includes={advancedIncludes}
          description={advancedDescription}
          image={advancedDetailImage}
        />
        <hr />
        <ProductStyleElements color={color} />
        <hr />
        <ProductImagery color={color} />
        <hr />
        <ProductPlanningTesting color={color} />
        <hr />
        <ProductEcommerce color={color} />
        <hr className="bg-below" />
        <ProductFooter background={footerBackground} />
      </div>
    </DocumentTitle>
  );
}

export default Website;



// WEBPACK FOOTER //
// ./src/pages/Website/index.js